import { useMemo } from 'react';
import { useAuth } from './useAuth';
import { useGetMembersQuery } from '../store/api/portalApi';

/**
 * Current user's role name in the active organisation (lowercase), or '' when
 * unknown. Matches by users.id, then by email (Cognito ``sub`` is not the
 * RDBMS users.id stored on members).
 */
export function useOrgRole(): { role: string; isLoading: boolean } {
  const { user, isInitializing } = useAuth();
  const orgId = user?.organizationId || '';
  const { data, isLoading: membersLoading } = useGetMembersQuery(
    { orgId, page: 1, pageSize: 100 },
    { skip: !orgId },
  );

  const role = useMemo(() => {
    if (!orgId || !data?.items?.length) return '';
    const me = data.items.find((m) => {
      if (user?.id && m.userId === user.id) return true;
      if (user?.email && m.email && m.email.toLowerCase() === user.email.toLowerCase()) {
        return true;
      }
      return false;
    });
    return (me?.roleName || '').toLowerCase();
  }, [data?.items, orgId, user?.email, user?.id]);

  return { role, isLoading: isInitializing || (!!orgId && membersLoading) };
}
